/* 🤖 this file was generated by svg-to-ts */
export const matIconForward: {
  name: 'forward';
  data: string;
} = {
  name: 'forward',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M14 8.83 17.17 12 14 15.17V14H6v-4h8V8.83M12 4v4H4v8h8v4l8-8-8-8z"/></svg>`
};
